<template>
  <div>
    <div>
      <DxDropDownButton
        :items="items"
        :drop-down-options="{ width: 141.41, maxHeight: 179 }"
        :scrollable="true"
        :text="$t('common.grid.selectActions')"
        class="selectActions"
        itemTemplate="actionsTemp"
      >
        <template #actionsTemp="{ data }">
          <div
            class="dropdown-wrapper"
            :class="{
              'hide-border':
                data.text ==
                items.filter((item) => item.visible)[
                  items.filter((item) => item.visible).length - 1
                ].text,
            }"
            title=""
            v-b-modal="data.modalId ? data.modalId : null"
            @click="actionChanged(data.id)"
          >
            <div class="dropdown-items" title="">
              {{ data.text }}
            </div>
          </div>
        </template>
      </DxDropDownButton>
    </div>
    <b-modal
      :id="'actionDuplicates' + selectedActionString"
      class="popover-modal"
      hide-header
      hide-footer
      no-close-on-esc
      ref="actionDuplicates"
    >
      <slot name="modal-header">
        <div class="modalHeader">
          <h4 class="modal-title">
            <slot name="modal-title">
              {{ $t(`integrations.${selectedActionString}`) }} {{ $t("integrations.duplicate") }}
            </slot>
          </h4>
        </div>
      </slot>
      <div class="d-block text-center modal-cusomContent">
        <p class="modal-paragraph">
          {{ $t("common.notes.areYouSureYouWant") }}<span class="bold-word">
            “{{ $t(`integrations.${selectedActionString}`) }}” </span
          >{{ $t("integrations.theDuplicate") }} {{ fullName }}?
        </p>
        <p class="modal-smallParagraph" v-if="selectedActionString == 'Skip'">
          {{ $t("integrations.skipNote") }}
        </p>
      </div>
      <div class="line"></div>
      <div class="action-btns">
        <b-button
          variant="primary"
          type="button"
          pill
          :disabled="getLoading"
          style="margin-inline-end: 31px !important"
          class="text-center modal-buttonSize"
          @click="submitAction()"
        >
          {{ $t(`integrations.${selectedActionString}`) }}
        </b-button>

        <b-button
          variant="outline-danger"
          type="button"
          pill
          :disabled="getLoading"
          class="text-center modal-buttonSize"
          @click="$bvModal.hide('actionDuplicates' + selectedActionString)"
        >
          {{  $t("common.cancel") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["dublicatesData"],
  components: {
    DxDropDownButton,
  },
  methods: {
    ...mapActions("integration", [
      "fixTempUsersWithDuplicates",
    ]),
    actionChanged(action) {
      console.log(this.dublicatesData, action);
      this.selectedUser = this.dublicatesData.selectedUser;
      this.selectedAction = action;
      this.selectedActionString = action == "3" ? "Merge" : "Skip";
      this.fullName =
        this.dublicatesData.first_name + " " + this.dublicatesData.last_name;
      this.id = this.dublicatesData.id;
      this.dir_int_id = this.dublicatesData.dir_int_id;
      setTimeout(() => {
        this.$bvModal.show("actionDuplicates" + this.selectedActionString);
      }, 300);
    },
    submitAction() {
      this.fixTempUsersWithDuplicates({
        selected_user_id: this.selectedUser,
        action: this.selectedAction,
        id: this.id,
        dir_int_id: this.dir_int_id,
      }).then(data => {
        this.$bvModal.hide("actionDuplicates" + this.selectedActionString);
        if (data.is_already_fixed) {
          this.$bvModal.show('alreadyFixedDuplicate');
        }
        this.$emit("refreshGrid");
      });
    },
  },
  data() {
    return {
      items: [],
      getSyncLogs: [],
      intgName: "",
      intgId: "",
      selectedUser: "",
      selectedAction: "",
      selectedActionString: "",
      fullName: "",
      id: "",
      dir_int_id: "",
    };
  },
  beforeMount() {
    this.items = [];
    this.items.push(
      {
        text: this.$t("integrations.Merge"),
        id: "3",
        visible: true,
      },
      {
        text: this.$t("integrations.Skip"),
        id: "2",
        visible: true,
      }
    );
  },
  computed: {
    ...mapGetters("integration", [
      "getLoading",
    ]),
  },
};
</script>

<style lang="scss">
.dropdown-wrapper {
  padding: 0;

  .dropdown-items {
    font-weight: 400;
    font-size: 16px !important;

    text-align: center;
    line-height: 19px !important;
    color: #787878 !important;

    margin: 6px auto !important;
    max-width: 142px !important;
    white-space: normal !important;
    padding: 1px 5px 1px 5px !important;
  }
}
</style>
